/**
 * Interrupteur unique du decor de bureau.
 *
 * `true` : le poste de travail vient de la scene de Bruno Simon (dossier 1),
 * importe tel quel en un seul groupe par BrunoDesk — clavier, souris, tapis,
 * MacBook, lampe, mugs, casque, tour et caissons, dans la disposition
 * d'origine.
 *
 * `false` : on retombe sur les objets proceduraux ecrits a la main
 * (DeskSet.buildMug/buildHeadset/..., GamerSetup.replacePeripherals,
 * WatercoolingTower). Les deux jeux se superposeraient sinon.
 *
 * Bascule a chaud, sans rebuild : ?bruno=0
 */
export const BRUNO_DESK = typeof window === 'undefined' ||
    new URLSearchParams(window.location.search).get('bruno') !== '0';
